// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.knfGo6L9E9aSoRi5ZfVn {
    width: 100%;
}

.azWzCx4LC7IS3PkoSx4h {
    left: 50%;
    margin-left: -70px;
    position: relative;
    width: max-content;
}

.azWzCx4LC7IS3PkoSx4h > img {
    height: 50px;
}

._jvqfJi8rWmHnCEq7gsI {
    position: relative;
    width: 100px;
    height: 100px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  ._jvqfJi8rWmHnCEq7gsI div {
    position: absolute;
    width: 14px;
    height: 14px;
    border-radius: 50%;
    animation: BP3XuzIphFGpTh35xZ37 1s infinite;
  }

  ._jvqfJi8rWmHnCEq7gsI div:nth-child(1) { transform: rotate(0deg) translate(40px); animation-delay: 0s; }
  ._jvqfJi8rWmHnCEq7gsI div:nth-child(2) { transform: rotate(40deg) translate(40px); animation-delay: 0.1s; }
  ._jvqfJi8rWmHnCEq7gsI div:nth-child(3) { transform: rotate(80deg) translate(40px); animation-delay: 0.2s; }
  ._jvqfJi8rWmHnCEq7gsI div:nth-child(4) { transform: rotate(120deg) translate(40px); animation-delay: 0.3s; }
  ._jvqfJi8rWmHnCEq7gsI div:nth-child(5) { transform: rotate(160deg) translate(40px); animation-delay: 0.4s; }
  ._jvqfJi8rWmHnCEq7gsI div:nth-child(6) { transform: rotate(200deg) translate(40px); animation-delay: 0.5s; }
  ._jvqfJi8rWmHnCEq7gsI div:nth-child(7) { transform: rotate(240deg) translate(40px); animation-delay: 0.6s; }
  ._jvqfJi8rWmHnCEq7gsI div:nth-child(8) { transform: rotate(280deg) translate(40px); animation-delay: 0.7s; }
  ._jvqfJi8rWmHnCEq7gsI div:nth-child(9) { transform: rotate(320deg) translate(40px); animation-delay: 0.8s; }

  .UvCzixCZt130DrkNnmpk {
    background: linear-gradient(
      90deg,
      rgba(141, 155, 184, 0.2) 25%,
      rgba(141, 155, 184, 0.08) 50%,
      rgba(141, 155, 184, 0.2) 75%
    );
    background-size: 200% 100%;
    animation: UvCzixCZt130DrkNnmpk 2.5s infinite;
  }

  @keyframes UvCzixCZt130DrkNnmpk {
    0% { background-position: 200% 0; }
    100% { background-position: -200% 0; }
  }

  @keyframes BP3XuzIphFGpTh35xZ37 {
    0%, 100% { width: 14px; height: 14px; background-color:rgba(24, 96, 217, 0.2);
;}
    50% { width: 21px; height: 21px; background-color: rgba(24, 96, 217, 1);
; }
  }
`, "",{"version":3,"sources":["webpack://./src/styles/Loader.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;AACf;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,2CAA6B;EAC/B;;EAEA,yCAA2B,uCAAuC,EAAE,mBAAmB,EAAE;EACzF,yCAA2B,wCAAwC,EAAE,qBAAqB,EAAE;EAC5F,yCAA2B,wCAAwC,EAAE,qBAAqB,EAAE;EAC5F,yCAA2B,yCAAyC,EAAE,qBAAqB,EAAE;EAC7F,yCAA2B,yCAAyC,EAAE,qBAAqB,EAAE;EAC7F,yCAA2B,yCAAyC,EAAE,qBAAqB,EAAE;EAC7F,yCAA2B,yCAAyC,EAAE,qBAAqB,EAAE;EAC7F,yCAA2B,yCAAyC,EAAE,qBAAqB,EAAE;EAC7F,yCAA2B,yCAAyC,EAAE,qBAAqB,EAAE;;EAE7F;IACE;;;;;KAKC;IACD,0BAA0B;IAC1B,6CAAgC;EAClC;;EAEA;IACE,KAAK,2BAA2B,EAAE;IAClC,OAAO,4BAA4B,EAAE;EACvC;;EAEA;IACE,WAAW,WAAW,EAAE,YAAY,EAAE,uCAAuC;CAChF;IACG,MAAM,WAAW,EAAE,YAAY,EAAE,sCAAsC;EACzE;EACA","sourcesContent":[".wrapper {\n    width: 100%;\n}\n\n.box {\n    left: 50%;\n    margin-left: -70px;\n    position: relative;\n    width: max-content;\n}\n\n.box > img {\n    height: 50px;\n}\n\n.loader {\n    position: relative;\n    width: 100px;\n    height: 100px;\n    margin: 0 auto;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .loader div {\n    position: absolute;\n    width: 14px;\n    height: 14px;\n    border-radius: 50%;\n    animation: resize 1s infinite;\n  }\n\n  .loader div:nth-child(1) { transform: rotate(0deg) translate(40px); animation-delay: 0s; }\n  .loader div:nth-child(2) { transform: rotate(40deg) translate(40px); animation-delay: 0.1s; }\n  .loader div:nth-child(3) { transform: rotate(80deg) translate(40px); animation-delay: 0.2s; }\n  .loader div:nth-child(4) { transform: rotate(120deg) translate(40px); animation-delay: 0.3s; }\n  .loader div:nth-child(5) { transform: rotate(160deg) translate(40px); animation-delay: 0.4s; }\n  .loader div:nth-child(6) { transform: rotate(200deg) translate(40px); animation-delay: 0.5s; }\n  .loader div:nth-child(7) { transform: rotate(240deg) translate(40px); animation-delay: 0.6s; }\n  .loader div:nth-child(8) { transform: rotate(280deg) translate(40px); animation-delay: 0.7s; }\n  .loader div:nth-child(9) { transform: rotate(320deg) translate(40px); animation-delay: 0.8s; }\n\n  .shimmer {\n    background: linear-gradient(\n      90deg,\n      rgba(141, 155, 184, 0.2) 25%,\n      rgba(141, 155, 184, 0.08) 50%,\n      rgba(141, 155, 184, 0.2) 75%\n    );\n    background-size: 200% 100%;\n    animation: shimmer 2.5s infinite;\n  }\n\n  @keyframes shimmer {\n    0% { background-position: 200% 0; }\n    100% { background-position: -200% 0; }\n  }\n\n  @keyframes resize {\n    0%, 100% { width: 14px; height: 14px; background-color:rgba(24, 96, 217, 0.2);\n;}\n    50% { width: 21px; height: 21px; background-color: rgba(24, 96, 217, 1);\n; }\n  }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `knfGo6L9E9aSoRi5ZfVn`,
	"box": `azWzCx4LC7IS3PkoSx4h`,
	"loader": `_jvqfJi8rWmHnCEq7gsI`,
	"resize": `BP3XuzIphFGpTh35xZ37`,
	"shimmer": `UvCzixCZt130DrkNnmpk`
};
export default ___CSS_LOADER_EXPORT___;
